module.exports = __webpack_public_path__ + "static/media/request_icon.22d5dfc7.svg";